"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.openAuthSession = exports.getAuthUserAgentValue = exports.getAuthUserAgentDetails = void 0;
var getAuthUserAgentDetails_1 = require("./getAuthUserAgentDetails");
Object.defineProperty(exports, "getAuthUserAgentDetails", { enumerable: true, get: function () { return getAuthUserAgentDetails_1.getAuthUserAgentDetails; } });
var getAuthUserAgentValue_1 = require("./getAuthUserAgentValue");
Object.defineProperty(exports, "getAuthUserAgentValue", { enumerable: true, get: function () { return getAuthUserAgentValue_1.getAuthUserAgentValue; } });
var openAuthSession_1 = require("./openAuthSession");
Object.defineProperty(exports, "openAuthSession", { enumerable: true, get: function () { return openAuthSession_1.openAuthSession; } });
